import React, { useState, useEffect } from "react";
import { Typography, Grid, Modal, Stack, Button } from "@mui/material";
import CategoryCard from "./CategoryCard";
import ACImage from "../../../assets/Images/ac_Image.png";
import CleaningImage from "../../../assets/Images/home_cleaning_Image.png";
import SalonImage from "../../../assets/Images/Salon_at_Home_Image.png";
import PlumbingImage from "../../../assets/Images/plumbling_Image.png";
import ElectricalImage from "../../../assets/Images/electrical_Image.png";
import AppliancesImage from "../../../assets/Images/appliances_Image.png";
import PackersImage from "../../../assets/Images/Packers_Movers_Image.png";
import PestImage from "../../../assets/Images/pest_control_Image.png";
import { Box } from "@mui/system";
import _ from "lodash";
import "../../../App.css";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";

const style = {
  position: "absolute",
  top: "25%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "white",
  p: 4,
};

const CategoriesCard = () => {
  const [open, setOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState({});
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const categoryClickHandler = (selectedobj) => {
    setSelectedCategory(selectedobj);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedCategory)) {
      setOpen(true);
    }
  }, [selectedCategory]);
  return (
    <div style={{ width: "90%", margin: "auto" }}>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Stack justifyContent="center" alignItems="center">
            <img
              src={selectedCategory.img}
              style={{ marginTop: "20px", marginBottom: "20px" }}
            />
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              style={{ marginBottom: "20px" }}
            >
              {selectedCategory.title}
            </Typography>
            <Stack
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <Link
                to="/create-request"
                state={{ requestParam: selectedCategory.title }}
              >
                <Button variant="contained" color="primary">
                  Post Request
                </Button>
              </Link>
              <Link to="/FindExperts" state={{ title: selectedCategory.title }}>
                <Button variant="outlined" color="primary">
                  Find Experts
                </Button>
              </Link>
            </Stack>
          </Stack>
        </Box>
      </Modal>
      <Typography
        variant="h5"
        component="h1"
        style={
          isMobile
            ? {
                marginTop: "30px",
                fontWeight: "600",
                fontSize: "32px",
                lineHeight: "24px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }
            : {
                marginTop: "30px",
                fontWeight: "600",
                fontSize: "32px",
                lineHeight: "24px",
              }
        }
      >
        Categories
      </Typography>
      <Grid container className="mt-4" rowSpacing={5}>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={ACImage}
            cardTitle="AC Services"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={CleaningImage}
            cardTitle="Cleaning Services"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={SalonImage}
            cardTitle="Salon and Self Care"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={PlumbingImage}
            cardTitle="Plumbing Services"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={ElectricalImage}
            cardTitle="Electrician Services"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={AppliancesImage}
            cardTitle="Appliances Maintenance"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={PackersImage}
            cardTitle="Packaging and Movers"
            categoryClick={categoryClickHandler}
          />
        </Grid>
        <Grid
          xs={12}
          sm={6}
          md={3}
          lg={3}
          item
          className="categories-card"
          style={
            isMobile
              ? {
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                }
              : null
          }
        >
          <CategoryCard
            cardImage={PestImage}
            cardTitle="Pest Control"
            categoryClick={categoryClickHandler}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default CategoriesCard;
